import Actions                           from 'Redux/Actions';
import { ofType }                        from 'redux-observable';
import { from }                          from 'rxjs';
import { mergeMap, catchError }          from 'rxjs/operators';
import { TEpic }                         from 'Redux/Config';
import { EventParentCategoryRepository } from 'Domain/Repositories';
import { message }                       from 'antd';

export const deleteEventParentCategoryEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.deleteEventParentCategoryRequest.type),
    mergeMap(action => from(EventParentCategoryRepository.remove(action.payload.id))
      .pipe(
        mergeMap(() => {
          message.success('Event Kategorie wurde erfolgreich gelöscht.');
          return from([
            Actions.deleteEventParentCategorySuccess({ id: action.payload.id }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.deleteEventParentCategoryFailure(error),
          ]);
        })
      )
    ),
  );
};
